import { mapCommandCenterClientProtection } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/clientProtection.utils';
import { brokerClientProtectionApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — the policy is optional and the endpoint 204s (and 403s on
// the DEV-3647 broker-auth gap) until it is published. Any non-success outcome
// must degrade to the empty state so the zone hides instead of reload-looping or
// surfacing an error toast on the login page.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_CLIENT_PROTECTION_ACTION_TYPE = createNamedActions(
  'commandCenterClientProtection',
  {
    SET_CLIENT_PROTECTION: 'SET_CLIENT_PROTECTION',
  },
);

export const getCommandCenterClientProtectionAction = () => async dispatch => {
  const policy = await brokerClientProtectionApi
    .getClientProtection({ config: SKIP_FORBIDDEN_CONFIG })
    .then(({ data }) => mapCommandCenterClientProtection(data ?? null))
    .catch(() => null);

  return dispatch({
    type: COMMAND_CENTER_CLIENT_PROTECTION_ACTION_TYPE.SET_CLIENT_PROTECTION,
    payload: policy,
  });
};
